import { ReducerKeys } from '../../config';
import { getState } from '../../store';
import { IAction, IActionMethods, StateStatus } from '../../utils/common';
import { IState } from './reducer';
import * as Types from './types';

/** Set FCM Action */
interface ISetFCMInput {
  token?: string;
  status: StateStatus;
}

class SetFCMToken implements IActionMethods {
  onPending(result?: any): IAction {
    throw new Error('Method not implemented.');
  }

  onSuccess(data: IState['fcmToken']['data']): IAction {
    return {
      type: Types.SET_FCM_TOKEN,
      data,
      status: StateStatus.Success,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_FCM_TOKEN,
      status: StateStatus.Failed,
      data: null,
    };
  }

  action(data: ISetFCMInput): IAction {
    if (data.status === StateStatus.Success) {
      return this.onSuccess(data.token ?? null);
    } else {
      return this.onFailed();
    }
  }
}

export default {
  setFCMTokenlAction: (data: ISetFCMInput) => new SetFCMToken().action(data),
};
